export abstract class TranslatorService {
  currentLanguage: string;

  abstract init(): Promise<void>;

  abstract getPreferredLanguage(): string;

  abstract translate(key: string, params?: object): string;

  abstract changeLanguage(language: string): Promise<void>;
}
